// Import Core
import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
// Import Libraries
import { GatsbyImage, getImage } from "gatsby-plugin-image";
// Import Utils
import { usePlaceholderImage } from "../../utils/useRandomPlaceholderImage";
import { getSlug } from "../../utils/getSlug";
import { toSlug } from "../../utils/search/toSlug";
import { getLinks } from "../../utils/getNavItemLinks";

const CardListStyling = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64px;
  @media (max-width: 768px) {
    align-items: flex-start;
    gap: 32px;
  }
  &.scrollable-mobile {
    @media (max-width: 768px) {
      max-height: 350px;
      overflow-y: scroll;
      margin-right: -10px;
      &::-webkit-scrollbar {
        width: 9px;
      }
    }
  }
  .card-list-items {
    display: flex;
    flex-wrap: wrap;
    row-gap: 20px;
    @media (max-width: 768px) {
      flex-direction: column;
      row-gap: 32px;
      margin-bottom: 0 !important;
    }
    .card {
      /* flex: 25%; */
      padding: 0 32px;
      border-right: 1px solid var(--neutral-10);
      display: flex;
      gap: 24px;
      &:first-child {
        padding: 0 32px 20px 0;
      }
      &:last-child {
        padding-right: 0;
        border-right: none;
      }
      flex: calc(50% - 10px);
      position: relative;
      margin-bottom: 20px;
      &:before {
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
        height: 1px;
        width: 100%;
        border-bottom: 1px solid var(--neutral-10);
      }
      &:nth-last-child(2) {
        &:before {
          border-bottom: unset;
        }
      }
      @media (max-width: 768px) {
        margin-bottom: 0;
        &:before {
          content: unset;
        }
      }
      &:nth-child(odd) {
        padding-left: 0;
      }
      &:nth-child(even) {
        padding-right: 0;
        border-right: none;
        padding-left: 32px;
        @media (max-width: 768px) {
          padding-left: 0;
        }
      }
      /* @media (max-width: 1200px) {
				flex-direction: column;
			} */
      @media (max-width: 768px) {
        flex: unset;
        gap: 32px;
        border-right: none;
        /* border-bottom: 1px solid var(--neutral-10); */
        padding: 0 0px 32px 0;
        flex-direction: column;
        &:first-child,
        &:nth-child(2) {
          margin-bottom: 0px;
          padding: 0 0px 32px 0;
          &:before {
            content: none;
          }
        }
        &:last-child {
          padding-bottom: 0;
          border-bottom: none;
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        flex: 1;

        @media (max-width: 768px) {
          gap: 12px;
        }
        .card-section-title {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 8px;
          .subheading {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            color: var(--neutral-75);
            gap: 8px;
            span {
            }
          }
        }
        .read-more-btn {
          padding-top: 8px;
          margin-top: auto;
          @media (max-width: 768px) {
            padding-top: 4px;
          }
        }
      }
      .card-image {
        width: 100px;
        height: 100px;
        /* @media (max-width: 1200px) {
					width: 100%;
				} */
        .gatsby-image-wrapper,
        img {
          object-fit: cover;
          width: inherit;
          height: inherit;
          max-height: inherit;
        }
        .placeholder-img {
          object-fit: contain;
        }
      }
    }
  }

  &.section-padding {
    padding: var(--global-padding);
    @media (max-width: 768px) {
      padding: var(--global-padding-mobile);
    }
    .card-list-items {
      width: 100%;
    }
  }
  &.three-col {
    .card-list-items {
      .card {
        /* flex-direction: column-reverse; */

        &:before {
          content: "";
          position: absolute;
          bottom: -20px;
          left: 0;
          height: 1px;
          width: 100%;
          border-bottom: 1px solid var(--neutral-10);
        }

        @media (min-width: 1200px) {
          flex: calc(33% - 20px);
        }
        @media (min-width: 1200px) {
          &:nth-child(3n - 1) {
            border-left: 1px solid var(--neutral-10);
            border-right: 1px solid var(--neutral-10);
            padding: 0 32px;
          }
          &:not(:nth-child(3n - 1)) {
            border-left: none;
            border-right: none;
            padding-right: 32px;
          }
        }
        /* &:nth-child(n + 4) {
					.card-image {
						display: none;
					}
				}
				@media (max-width: 1200px) {
					&:nth-child(n + 3) {
						.card-image {
							display: none;
						}
					}
				}
				@media (max-width: 768px) {
					&:not(:first-child) {
						.card-image {
							display: none;
						}
					}
				} */
        &:nth-child(odd) {
          padding: 0 32px;
          @media (max-width: 768px) {
            padding: 0 0 32px;
          }
        }
        /* .content {
					.short-excerpt {
						overflow: hidden;
						display: -webkit-box;
						-webkit-line-clamp: 4;
						line-clamp: 4;
						-webkit-box-orient: vertical;
					}
					
					
				} */
        /* .card-image {
					@media (min-width: 1200px) {
						width: 100%;
						.gatsby-image-wrapper,
						img {
							width: 100%;
						}
						.placeholder-img {
							object-fit: cover;
						}
					}
				} */
      }
    }
  }
`;

const getTagline = (tagline, card, isInEurope) => {
  // console.log(tagline, card, isInEurope);
  // If flexible content will need to get the tagline from card
  if (card.tagline) {
    return card.tagline;
  } else if (tagline === "continent") {
    if (card.city && card.city !== "undefined" && card.city !== "null") {
      return card.city.name;
    } else if (
      card.country &&
      card.country !== "undefined" &&
      card.country !== "null"
    ) {
      return card.country.name;
    } else {
      if (card.isInEurope) {
        return card.isInEurope === "europe" ? "Europe" : "Further Afield";
      } else {
        return isInEurope === "europe" ? "Europe" : "Further Afield";
      }
    }
  } else {
    return tagline;
  }
};

const CardSimple = ({
  index,
  card,
  randomPlaceholderImage,
  tagline,
  addLinks,
  isInEurope,
}) => {
  const navItem = { name: card?.title, navItemUrl: card?.navItemUrl };
  const linkData =
    navItem && navItem.name && navItem.navItemUrl ? getLinks(navItem) : null;

  return addLinks || linkData ? (
    <Link
      to={addLinks ? getSlug(card) : linkData.link}
      className="card"
      key={`card-${index}`}
    >
      {/* Data is too hit and miss for predictable pictures */}
      {/* <div className='card-image'>
				{card.image && card.image.asset ? (
					<GatsbyImage image={getImage(card.image.asset)} alt={`${card.title ? card.title : card.name}`} />
				) : (
					<img
						src={randomPlaceholderImage}
						alt={card.title}
						className='placeholder-img'
					/>
				)}
			</div> */}

      <div className="content">
        <div className="card-section-title">
          {(tagline || card.tagline) && (
            <p className="tagline small">
              {getTagline(tagline, card, isInEurope)}
            </p>
          )}
          <h5 className="alt title">{card.title ? card.title : card.name}</h5>
        </div>
        {/* <Link to={getSlug(card)} className='read-more-btn'></Link> */}
      </div>
    </Link>
  ) : (
    <div className="card" key={`card-${index}`}>
      <div className="card-image">
        {card.image && card.image.asset ? (
          <GatsbyImage
            image={getImage(card.image.asset)}
            alt={`${card.title ? card.title : card.name}`}
          />
        ) : (
          <img
            src={randomPlaceholderImage}
            alt={card.title}
            className="placeholder-img"
          />
        )}
      </div>

      <div className="content">
        <div className="card-section-title">
          {(tagline || card.tagline) && (
            <p className="tagline small">
              {getTagline(tagline, card, isInEurope)}
            </p>
          )}
          <h5 className="alt title">{card.title ? card.title : card.name}</h5>
        </div>
        {/* <Link to={getSlug(card)} className='read-more-btn'></Link> */}
      </div>
    </div>
  );
};

const CardListSimple = ({
  addPadding = false,
  addToAnchor = false,
  title = "",
  tagline,
  cardList,
  addLinks = false,
  threeCol = true,
  isInEurope,
}) => {
  const { randomPlaceholderImage } = usePlaceholderImage();

  return (
    <CardListStyling
      id={addToAnchor ? `anchor_${toSlug(title)}` : ""}
      className={`card-list-simple ${addToAnchor && " anchor-link"}${
        addPadding && " section-padding"
      }${threeCol && " three-col"} ${
        cardList.length > 6 && `scrollable-mobile`
      }`}
    >
      {title && (
        <div className="section-title">
          <h3>{title}</h3>
        </div>
      )}
      <div className="card-list-items">
        {cardList.map((card, index) => (
          <CardSimple
            key={index}
            index={index}
            card={card}
            randomPlaceholderImage={randomPlaceholderImage}
            tagline={tagline}
            addLinks={addLinks}
            isInEurope={isInEurope}
          />
        ))}
      </div>
    </CardListStyling>
  );
};

export default CardListSimple;
